<template>
    <div class="center">
        <p class="pd" style="display: flex;align-items: center;padding-left: 65px">原因:<el-input v-model.trim="input" style="width: 200px" :placeholder="selectVal.goodsName"></el-input></p>

        <p class="pd" style="display: flex;align-items: center">请选择延长日期 <el-date-picker
                style="width: 200px;"
                v-model="value"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd">
        </el-date-picker></p>
        <span slot="footer" class="dialog-footer"  style="padding-bottom: 20px">
    <el-button @click="cancel1">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="cancel">确 定</el-button>
  </span>
    </div>
</template>
<script>
    import * as API from  "../api";
    import {mapActions} from "vuex";
    import data from "../data.json"
    export default {
        name: 'TiHhuo',
        props:{
            selectVal:{
                type:Object,
                required:true}
        },
        data() {
            return {
                input:'',
                value:'',
                center:false
            }
        },
        mounted() {


        },
        destroyed(){

        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            cancel1(){
                this.$emit('close2')
            },
            cancel(){
                this.yanchangtihuo()
                // this.$emit('close2')

                // this.$emit('th',this.value)
                // this.$parent.getOrderManagerList()
            },
            //延长提货时间
            async yanchangtihuo(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };

                let param={
                    id:this.selectVal.id,
                    token:sessionStorage.getItem("token"),
                    version:"",
                    app:"",
                    i_uid:sessionStorage.getItem("userid"),
                    reason:this.input,
                    i_mid:this.mid,
                    overduetime:this.value
                };
                let res=await API.yctihuoorder(param)
                if(res.code==1){
                    // this.select=res.list.status;
                    // this.select1=res.list.isConsignShip;
                    //console.log(res)
this.$emit('getOrderManagerList',this.center)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };

            },
        }
    }
</script>
<style lang="scss" scoped>
    .center{
        display: flex;
        align-items: center;
        flex-direction:column;
    }
    .pd{
        padding: 20px 0 0 0;
    }
</style>